// libs
import React from 'react';
import PropTypes from 'prop-types';

// Component
import Default from './default/Default';
import Home from './home/Home';
import Landing from './landing/Landing';
import Search from './search/Search';
import Lexique from './lexique/Lexique';

// Props and Context
const propTypes = {
  id: PropTypes.number.isRequired,
  preview: PropTypes.bool,
  templateName: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

const defaultProps = {
  preview: false,
};

function Page(props) {
  const {
    id,
    preview,
    templateName,
    slug,
  } = props;
  const pageComponent = {
    search: <Search slug={slug} />,
    lexicon: <Lexique slug={slug} />,
    landing: <Landing slug={slug} preview={preview} id={id} />,
    home: <Home />,
    default: <Default slug={slug} preview={preview} id={id} />,
  };
  return (
    <React.Fragment>
      {pageComponent[templateName]}
    </React.Fragment>
  );
}

Page.propTypes = propTypes;
Page.defaultProps = defaultProps;

export default Page;



// WEBPACK FOOTER //
// ./src/app/components/pages/Page.js